<template>
    <b-modal :visible="visible" title="Подтверждение начисления за месяц" size="xl" scrollable
        :no-close-on-backdrop="pending" :no-close-on-esc="pending" :hide-header-close="pending"
        @change="$emit('update:visible', $event)" @hidden="invalidate">
        <div v-if="loading" class="text-muted" role="status">Загружаем все объекты и формулы…</div>
        <p v-else class="scope-note">Подтверждаются все объекты сотрудника за месяц в указанной валюте. Фильтры списка не ограничивают состав.</p>
        <details v-for="(item, index) in items" :key="item.context.line.id" class="confirmation-employee" :open="index === 0">
            <summary><strong>{{ item.context.line.employee_name_snapshot }}</strong><span>{{ item.context.month }} · {{ money(item.payload.final_amount_minor, item.context.run.currency) }}</span></summary>
            <div class="employee-actions"><span>{{ progress(item.payload.object_review) }}</span><b-button size="sm" variant="outline-primary" :disabled="pending" @click="$emit('edit', item.context, null)">Изменить</b-button></div>
            <PayrollLineEditor :payload="item.payload" :context="item.context" hide-footer confirmation-mode
                @edit="$emit('edit', item.context, $event)" @source="$emit('source', item.context, $event)" />
        </details>
        <template #modal-footer>
            <div class="confirmation-footer">
                <div v-if="error" class="alert alert-danger mb-2" role="alert">{{ error }} <button v-if="!pending" type="button" class="btn btn-sm btn-outline-danger" @click="load">Обновить состав</button></div>
                <div class="confirmation-totals"><strong v-for="total in totals" :key="total.currency">За месяц: {{ money(total.amount, total.currency) }}</strong></div>
                <div class="confirmation-actions"><b-button :disabled="pending" @click="$emit('update:visible', false)">Закрыть</b-button><b-button v-if="items.length === 1" variant="outline-primary" :disabled="pending || loading" @click="$emit('edit', items[0].context, null)">Изменить</b-button><b-button variant="success" :disabled="pending || loading || Boolean(error) || items.length !== contexts.length || !items.length" @click="confirm">{{ pending ? 'Подтверждение…' : 'Подтвердить все объекты за месяц' }}</b-button></div>
            </div>
        </template>
    </b-modal>
</template>
<script>
import api from '@/utils/api';
import PayrollLineEditor from './PayrollLineEditor.vue';
export default {
    name: 'PayrollConfirmationDialog',
    components: {PayrollLineEditor},
    props: {visible: Boolean, contexts: {type: Array, default: () => []}},
    data: () => ({items: [], loading: false, pending: false, error: '', request: 0}),
    computed: {
        totals() {
            const totals = new Map();
            this.items.forEach(item => { const currency = item.context.run.currency; totals.set(currency, (totals.get(currency) || 0) + Number(item.payload.final_amount_minor)); });
            return Array.from(totals, ([currency, amount]) => ({currency, amount}));
        }
    },
    watch: {visible(value) { if (value) this.load(); else this.invalidate(); }},
    beforeDestroy() { this.invalidate(); },
    methods: {
        invalidate() { this.request++; this.items = []; this.error = ''; this.loading = false; },
        money(amount, currency) { return amount == null ? 'Не распределено' : `${(Number(amount) / 100).toLocaleString('ru-RU', {minimumFractionDigits: 2, maximumFractionDigits: 2})} ${currency}`; },
        progress(value) { return value ? `Подтверждено ${value.confirmed_count} из ${value.total_count} объектов` : ''; },
        async load() {
            if (this.pending) return;
            const request = ++this.request; this.loading = true; this.error = ''; this.items = [];
            try {
                const contexts = this.contexts.slice(), items = [];
                for (let offset = 0; offset < contexts.length; offset += 4) {
                    const batch = await Promise.all(contexts.slice(offset, offset + 4).map(async context => ({context,
                        payload: (await api.get(`/api/payroll/lines/${context.line.id}/explanation`, {ignoreModal: true})).data})));
                    if (request !== this.request) return;
                    items.push(...batch);
                }
                this.items = items;
            } catch (error) {
                if (request === this.request) this.error = error.response && error.response.data && error.response.data.msg || 'Не удалось загрузить полный состав начислений.';
            } finally { if (request === this.request) this.loading = false; }
        },
        async confirm() {
            if (this.pending || this.loading || this.error || this.items.length !== this.contexts.length || !this.items.length) return;
            this.pending = true; this.error = '';
            try {
                await api.post('/api/payroll/lines/confirm', {scope: 'month', decisions: this.items.map(item => ({line_id: item.context.line.id, expected_revision: item.payload.edit_revision}))}, {ignoreModal: true});
                this.$emit('confirmed');
            } catch (error) { this.error = error.response && error.response.data && error.response.data.msg || 'Не удалось подтвердить начисление.'; }
            finally { this.pending = false; }
        }
    }
};
</script>
<style scoped>
.scope-note { color: #52677c; }
.confirmation-employee { border: 1px solid #d6e1ec; border-radius: 8px; margin-bottom: 12px; background: #fff; }
summary { display: flex; flex-wrap: wrap; justify-content: space-between; gap: 8px; padding: 12px; cursor: pointer; background: #f5f9fc; }
.employee-actions { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 8px; padding: 8px 12px; color: #52677c; }
.confirmation-footer { width: 100%; }
.confirmation-totals, .confirmation-actions { display: flex; justify-content: flex-end; flex-wrap: wrap; gap: 8px; }
.confirmation-totals { margin-bottom: 8px; }
.confirmation-employee >>> .editor-body { overflow: visible; }
@media (max-width: 600px) { .confirmation-actions .btn-success { width: 100%; } }
</style>
